/**
 * P-03 — Klaviyo popup hygiene
 * Gate form UI until RSConsent.marketing; suppress the noisy console error.
 * Suppress onsite popups on cart, ATC sheet, and bundle/offer journey pages.
 * Elsewhere: after signup, close popup and stay put (block /products/dein-set redirect).
 */
(function () {
  var STYLE_ID = 'rs-klaviyo-consent-css';
  var SUPPRESS_STYLE_ID = 'rs-klaviyo-suppress-css';
  var DEIN_SET_RE = /\/products\/dein-set\/?(?:\?|#|$)/i;
  var BUNDLE_PATH_RE = /\/(pages\/(bundle|bundle[2-5]|duo|trio|set|coldads)|products\/dein-set|products\/bio-starter-set)\/?(?:\?|#|$)/i;

  function marketingOk() {
    try {
      if (window.RSConsent && window.RSConsent.marketing) return true;
      if (document.documentElement.dataset.rsMarketing === '1') return true;
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed()) return true;
    } catch (e) {}
    return false;
  }

  function onCartPage() {
    try {
      if (window.Shopify && Shopify.routes && typeof location !== 'undefined') {
        var path = location.pathname || '';
        if (path === '/cart' || path.indexOf('/cart/') === 0) return true;
      }
      return document.body && document.body.classList.contains('template-cart');
    } catch (e) {
      return false;
    }
  }

  function onBundleJourney() {
    try {
      var path = (location.pathname || '').toLowerCase();
      if (BUNDLE_PATH_RE.test(path)) return true;
      if (document.body && (
        document.body.classList.contains('template-page-coldads') ||
        document.body.classList.contains('template-page-coldads2') ||
        document.body.classList.contains('template-page-coldads3') ||
        document.body.classList.contains('template-page-coldads4') ||
        document.body.classList.contains('template-page-coldads5') ||
        document.body.classList.contains('template-product-bundles') ||
        document.body.classList.contains('template-product-personalisiertes-set')
      )) return true;
      if (document.documentElement.dataset.rsOfferJourney === '1') return true;
    } catch (e) {}
    return false;
  }

  function atcSheetOpen() {
    try {
      if (document.body && document.body.classList.contains('rs-atc-lock')) return true;
      var sheet = document.querySelector('.rs-atc.is-open, .rs-atc-backdrop.is-open');
      return !!sheet;
    } catch (e) {
      return false;
    }
  }

  function shouldSuppressPopup() {
    return onCartPage() || atcSheetOpen() || onBundleJourney();
  }

  function ensureCss() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      'html:not([data-rs-marketing="1"]) .klaviyo-form-WJTh2z,' +
      'html:not([data-rs-marketing="1"]) [class*="klaviyo-form"][role="dialog"],' +
      'html:not([data-rs-marketing="1"]) .needsclick.go2877328810,' +
      'html:not([data-rs-marketing="1"]) div[aria-label="POPUP Form"] {' +
      '  display: none !important; visibility: hidden !important; pointer-events: none !important;' +
      '}';
    document.head.appendChild(s);
  }

  function ensureSuppressCss() {
    if (document.getElementById(SUPPRESS_STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = SUPPRESS_STYLE_ID;
    s.textContent =
      'html[data-rs-klaviyo-suppress="1"] .klaviyo-form,' +
      'html[data-rs-klaviyo-suppress="1"] [class*="klaviyo-form"],' +
      'html[data-rs-klaviyo-suppress="1"] [class*="kl-private-reset"],' +
      'html[data-rs-klaviyo-suppress="1"] .needsclick.kl-teaser,' +
      'html[data-rs-klaviyo-suppress="1"] .needsclick.go2877328810,' +
      'html[data-rs-klaviyo-suppress="1"] div[aria-label="POPUP Form"],' +
      'html[data-rs-klaviyo-suppress="1"] iframe[title*="Klaviyo" i] {' +
      '  display: none !important; visibility: hidden !important; pointer-events: none !important;' +
      '}';
    document.head.appendChild(s);
  }

  function closeKlaviyoForms() {
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['closeForm']);
      }
      if (window._klOnsite && typeof window._klOnsite.push === 'function') {
        window._klOnsite.push(['closeForm']);
      }
    } catch (e) {}
  }

  function isDeinSetUrl(url) {
    if (!url) return false;
    try {
      var abs = new URL(String(url), location.origin);
      if (abs.origin !== location.origin) return false;
      return DEIN_SET_RE.test(abs.pathname);
    } catch (e) {
      return DEIN_SET_RE.test(String(url));
    }
  }

  function stayAfterSignup() {
    closeKlaviyoForms();
  }

  function blockDeinSetRedirect() {
    if (window.__rsKlaviyoRedirectBlocked) return;
    window.__rsKlaviyoRedirectBlocked = true;

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var inKl = a.closest('.klaviyo-form, [class*="klaviyo-form"], [class*="kl-private-reset"], div[aria-label="POPUP Form"]');
      if (!inKl) return;
      if (!isDeinSetUrl(a.getAttribute('href'))) return;
      e.preventDefault();
      e.stopPropagation();
      stayAfterSignup();
    }, true);

    var _assign = window.location.assign.bind(window.location);
    var _replace = window.location.replace.bind(window.location);
    try {
      window.location.assign = function (url) {
        if (isDeinSetUrl(url)) {
          stayAfterSignup();
          return;
        }
        return _assign(url);
      };
      window.location.replace = function (url) {
        if (isDeinSetUrl(url)) {
          stayAfterSignup();
          return;
        }
        return _replace(url);
      };
    } catch (e) {}

    try {
      var desc = Object.getOwnPropertyDescriptor(Location.prototype, 'href') ||
        Object.getOwnPropertyDescriptor(window.location, 'href');
      if (desc && desc.set) {
        var rawSet = desc.set;
        Object.defineProperty(window.location, 'href', {
          configurable: true,
          enumerable: true,
          get: desc.get ? desc.get.bind(window.location) : function () { return String(window.location); },
          set: function (url) {
            if (isDeinSetUrl(url)) {
              stayAfterSignup();
              return;
            }
            return rawSet.call(window.location, url);
          }
        });
      }
    } catch (e2) {}
  }

  function syncFormFlag() {
    try {
      if (!marketingOk()) closeKlaviyoForms();
    } catch (e) {}
  }

  function syncSuppress() {
    ensureSuppressCss();
    var suppress = shouldSuppressPopup();
    document.documentElement.dataset.rsKlaviyoSuppress = suppress ? '1' : '0';
    if (suppress) closeKlaviyoForms();
  }

  function patchConsole() {
    if (console.__rsKlaviyoPatched) return;
    console.__rsKlaviyoPatched = true;
    var origError = console.error;
    var origWarn = console.warn;
    function mute(fn) {
      return function () {
        try {
          var msg = Array.prototype.slice.call(arguments).join(' ');
          if (/Popup form submissions are blocked/i.test(msg)) return;
          if (/klaviyo.*blocked/i.test(msg) && !marketingOk()) return;
        } catch (e) {}
        return fn.apply(console, arguments);
      };
    }
    console.error = mute(origError);
    console.warn = mute(origWarn);
  }

  function onConsent() {
    ensureCss();
    syncFormFlag();
    syncSuppress();
    document.documentElement.dataset.rsMarketing = marketingOk() ? '1' : '0';
  }

  ensureCss();
  ensureSuppressCss();
  patchConsole();
  blockDeinSetRedirect();
  onConsent();

  document.addEventListener('rs:consent', onConsent);
  document.addEventListener('tinycookie:consent', onConsent);
  document.addEventListener('cookieyes_consent_update', function () {
    document.documentElement.dataset.rsMarketing = '1';
    onConsent();
  });

  var mo = new MutationObserver(function () {
    syncSuppress();
  });
  if (document.body) {
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      syncSuppress();
    });
  }

  var n = 0;
  var t = setInterval(function () {
    n += 1;
    onConsent();
    if (n > 60) clearInterval(t);
  }, 500);
})();
